import config from '../config';
import { requestAnalyticSetUp } from './analytics';
import jwtDecode from 'jwt-decode';

export const LOGIN_RESET = 'LOGIN_RESET';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SET_UNAUTHORIZED_MESSAGE_VISIBLE =
  'SET_UNAUTHORIZED_MESSAGE_VISIBLE';

function requestLogin() {
  return {
    type: LOGIN_REQUEST
  };
}

function receiveLogin(token) {
  return {
    type: LOGIN_SUCCESS,
    token
  };
}

function loginError(err) {
  return {
    type: LOGIN_FAILURE,
    err
  };
}

function handleErrors(res) {
  if (!res.ok) {
    throw Error(`${res.status} ${res.statusText}`);
  }
  return res;
}

export function resetLogin() {
  return {
    type: LOGIN_RESET
  };
}

export function loginAccount(creds, history) {
  return dispatch => {
    dispatch(requestLogin());

    return fetch(`${config.api.baseURL}/login`, {
      method: 'POST',
      body: JSON.stringify(creds),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        dispatch(requestAnalyticSetUp(jwtDecode(json.token).analyticsId));
        dispatch(receiveLogin(json.token));
      })
      .then(res => {
        history.push('/dashboard');
      })
      .catch(err => dispatch(loginError(err.name)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/login.js